import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./store";

export const useHomeData = () => {
  const [products, setProducts] = useState([]);
  const [blog, setBlog] = useState([]);
  const [igPosts, setIgPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/products?featured=true`).then((r) => setProducts(r.data));
    axios.get(`${API}/blog`).then((r) => setBlog(r.data.slice(0, 3)));
    axios.get(`${API}/instagram/feed`).then((r) => setIgPosts(r.data.posts || [])).catch(() => {});
  }, []);

  return { products, blog, igPosts };
};

export const HERO_VIDEO_SRC = "https://www.youtube.com/embed/B850Uw0n9OE?autoplay=1&mute=1&loop=1&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&playlist=B850Uw0n9OE";

export const HeroVideo = ({ videoSrc, overlay = "linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.4) 100%)" }) => (
  <>
    <div className="hero-video-wrap">
      <iframe
        src={videoSrc || HERO_VIDEO_SRC}
        title="SharkX Hero"
        frameBorder="0"
        allow="autoplay; encrypted-media; picture-in-picture"
        loading="eager"
      />
    </div>
    <div className="absolute inset-0" style={{ background: overlay }} />
  </>
);
